<template>
  <div id="home">

    <div class="content">
      <div class="flex"><el-input v-model="keywords" @change="searchFunction" placeholder="name, Chart No"></el-input></div>

      <el-table
        v-loading="table_loading"
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        style="width: 100%;">
        <el-table-column
          align="center"
          min-width="100px"
          label="Name">
          <template slot-scope="scope">
            {{scope.row.firstName}} {{scope.row.lastName}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="caseHistoryStatus"
          min-width="100px"
          label="Status">
        </el-table-column>
        <el-table-column
          align="center"
          prop="chartNo"
          min-width="100px"
          label="Chart No">
        </el-table-column>
        <!-- <el-table-column
          prop="product"
          min-width="150px"
          align="center"
          label="Product">
        </el-table-column>
        <el-table-column
          prop="shared"
          align="center"
          min-width="150px"
          label="Shared">
        </el-table-column> -->
        <el-table-column
          align="center"
          min-width="100px"
          label="Date Time">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: center;">
              <p style="text-align: left;">
                {{moment(scope.row.createTime).format("MM-DD-yyyy")}}<br/>
                {{moment(scope.row.createTime).format("HH:mm:ss")}}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          min-width="80px"
          align="center">
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-more" style="cursor: pointer;"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scope.row.caseHistoryStatus == 'Completed' || scope.row.caseHistoryStatus == 'Archived'"><div @click.stop="show(scope.row.id)"><i class="font-size-16 el-icon-search"></i>Active view</div></el-dropdown-item>
                <el-dropdown-item v-if="scope.row.caseHistoryStatus == 'Completed' || scope.row.caseHistoryStatus == 'Archived'"><div @click.stop="show_edit(scope.row.id)"><i class="font-size-16 el-icon-circle-check"></i>Candidate view</div></el-dropdown-item>
                <el-dropdown-item v-if="scope.row.caseHistoryStatus == 'Completed' || scope.row.caseHistoryStatus == 'Archived'"><div @click.stop="downloadInfo(scope.row.id)"><i class="font-size-16 el-icon-download"></i>Download</div></el-dropdown-item>
                <el-dropdown-item><div @click.stop="removeInfo(scope.row.id)"><i class="font-size-16 el-icon-delete"></i>Delete</div></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
      <!-- <el-dialog
        :visible.sync="downloadShow"
        top="30vh"
        :center="true"
        :show-close="false"
        width="440px">
        <div style="display: flex;flex-direction: column;align-items: center;color: #262626;">
          <i class="el-icon-document-checked" style="color: #3EA19D;font-size: 70px;"></i>
          <h1 style="font-size: 30px;font-weight: normal;line-height: 1;margin:10px 0 20px 0;">Your file is ready!</h1>
          <p style="color: #717D96;">Do you really want to delete this records?</p>
          <p style="color: #717D96;">This process cannot be undone.</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" size="small" @click="downloadShow = false">Cancel</el-button>
          <el-button type="primary" size="small" @click="downloadImage" style="background-color:#3EA19D;border-color: #3EA19D;">Download</el-button>
        </span>
      </el-dialog> -->
      <el-dialog
        :visible.sync="deleteShow"
        top="30vh"
        :center="true"
        :show-close="false"
        width="440px">
        <div style="display: flex;flex-direction: column;align-items: center;color: #262626;">
          <i class="el-icon-circle-close" style="color: #FF4528;font-size: 70px;"></i>
          <h1 style="font-size: 30px;font-weight: normal;line-height: 1;margin:10px 0 20px 0;">Are you sure?</h1>
          <p style="color: #717D96;">Do you really want to delete this records?</p>
          <p style="color: #717D96;">This process cannot be undone.</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" size="small" @click="deleteShow = false">Cancel</el-button>
          <el-button type="primary" size="small" @click="remove" style="background-color:#FF4528;border-color: #FF4528;">Delete</el-button>
        </span>
      </el-dialog>
      <download ref="downloadForm"></download>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction,deleteAction } from '@/network/manage';
  import moment from 'moment/moment';
  import Download from './orthodonticSmile/Download'
  export default {
    name: 'AccountManagement',
    components: {
      Download
    },
    data() {
      return {
        keywords:'',
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        downloadShow: false,
        downloadUrl:'',
        deleteShow:false,
        deleteId:'',
        table_loading: false
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.getDatas(1)
    },
    methods:{
      moment,
      show(id) {
        this.$router.push('/orthodonticSmileShow?id='+id)
      },
      remove(){
        this.deleteShow = false
        this.table_loading = true
        deleteAction("/admin/caseHistory/delete?id="+this.deleteId).then((res) => {
          if(res.success){
            this.$message({
              type: 'success',
              message: 'delete success!'
            });
            this.searchFunction()
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {

        }).finally((res) => {
          this.table_loading = false
        })
      },
      removeInfo(id){
        this.deleteId = id
        this.deleteShow = true
      },
      downloadInfo(id){
        this.$refs.downloadForm.init(id)
      },
      show_edit(id) {
        this.$router.push('/orthodonticSmileEdit?id='+id)
      },
      searchFunction(){
        this.getDatas(1)
      },
      getDatas(initSize) {
        if(initSize == 1) {
          this.current_page = 1
        } else {
          this.current_page = initSize
        }
        this.table_loading = true
        getAction("/admin/caseHistory/list?pageSize=" + this.page_size + "&pageNo=" + this.current_page,{keywords:this.keywords}).then((res) => {
          if(res.success){
            this.tableData = res.result.records
            this.totalRows = res.result.total
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {

        }).finally((res) => {
          this.table_loading = false
        })
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      },
      /* downloadImage(){
        this.downloadShow = false
        var url = process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + this.downloadUrl
        var image = new Image()
        image.setAttribute("crossorigin","anonymous")
        image.onload = function() {
          var canvas = document.createElement("canvas")
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext("2d")
          context.drawImage(image,0,0,image.width,image.height)
          var url = canvas.toDataURL("image/png")
          var a = document.createElement("a")
          var event = new MouseEvent("click")
          a.download = "image"
          a.href = url
          a.dispatchEvent(event)
        }
        image.src = url
      } */
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#E6ECEB;padding:20px;min-height: calc(100vh - 70px);}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .flex{display: flex;justify-content: flex-end;width: 400px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 18px;color:#000000;}
  .font-size-16:hover{color:#3EA19D;text-decoration: none;}
  @media (max-width: 768px) {
    #home{padding:0;background-color:#ffffff;}
    .content{padding:20px 20px;border-radius: 0px;box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);}
    .flex{width: 100%;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
